import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import Form from './Form'

export default injectIntl(({ lot, fields, info, intl }) => (
  <div className='Error'>
    <div className='Container Container_light'>
      <div className='Error__body'>
        <div className='Error__person'>
          <div className='Error__img-wrap'>
            <img src={lot.image} alt={lot.title} className='Error__img' />
            <div className='Error__overlay' />
          </div>
          <h1 className='Error__hline'>
            <FormattedMessage id='payment_error.error' />
          </h1>
        </div>

        {<Form fields={fields} url={info.url} btnTitle={intl.formatMessage({id: 'payment_error.try_again'})} />}
      </div>
    </div>
  </div>
))



// WEBPACK FOOTER //
// ./src/components/Payment/Error.jsx